module.exports = __webpack_public_path__ + "static/media/notify-checklist.b0f2ce95.svg";